var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#FF9800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.849 22.25c.6 0 1.2-.45 1.2-1.05 0-.75-.6-1.2-1.2-1.2s-1.05.45-1.05 1.05c0 .6.45 1.2 1.05 1.2zM12.5 6.5h2.7l-.45 11.7h-1.8L12.5 6.5z",
    fill: "#fff"
  })));
}
export default SvgWarning;